import { Flex, ProgressCircle } from '@adobe/react-spectrum';

/**
 * Loader Component
 * 
 * Reusable loading indicator used across mobile components.
 */
export function Loader() {
  return (
    <Flex width="100%" justifyContent="center" marginTop={10} UNSAFE_style={{ backgroundColor: 'inherit' }}>
      <ProgressCircle aria-label="Loading…" isIndeterminate />
    </Flex>
  );
}

